import React from 'react';
import { motion } from 'framer-motion';
import { FeatherIcon } from 'lucide-react';
export const CTA = () => {
  return <section className="py-24 bg-burgundy-800 relative overflow-hidden border-y border-gold-600/30" data-id="element-12">
      {/* Background radial gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-burgundy-700 via-burgundy-900 to-burgundy-950" data-id="element-13"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-15">
          <div className="flex justify-center mb-6" data-id="element-16">
            <FeatherIcon className="w-12 h-12 text-gold-500" data-id="element-17" />
          </div>
          <h2 className="font-display text-5xl md:text-6xl text-gold-400 mb-6 text-shadow-gold" data-id="element-18">
            Your Legend Awaits
          </h2>
          <p className="text-xl text-parchment-200 mb-10 max-w-2xl mx-auto" data-id="element-19">
            Join the premier syndication network for fantasy and entertainment.
            Let us carry your words to the furthest reaches of the realm.
          </p>

          <form className="flex flex-col sm:flex-row gap-4 justify-center max-w-lg mx-auto" onSubmit={e => e.preventDefault()} data-id="element-20">
            <input type="email" placeholder="Enter your electronic missive (email)" className="flex-1 bg-burgundy-950/80 border border-gold-700/50 text-parchment-100 px-6 py-4 focus:outline-none focus:border-gold-500 focus:ring-1 focus:ring-gold-500 placeholder-parchment-400/50 font-body text-lg" required data-id="element-21" />
            <button type="submit" className="bg-gold-600 text-burgundy-950 px-8 py-4 font-heading font-bold uppercase tracking-widest hover:bg-gold-500 transition-colors shadow-gold-glow whitespace-nowrap" data-id="element-22">
              Send Raven
            </button>
          </form>
          <p className="text-parchment-400 text-sm mt-4 italic" data-id="element-23">
            We guard your contact details as fiercely as a dragon guards its
            hoard.
          </p>
        </motion.div>
      </div>
    </section>;
};